const pl = {
    enter_code: "Identyfikator sesji",
    connect: "Łączyć",
    check_your_internet_connection: "Sprawdź połączenie internetowe.",
    network_error: "Błąd sieciowy",
    server_error: "Błąd serwera",
    check_server_connection: "Wewnętrzny błąd serwera",
    downtime: "Czas przestoju",
    server_is_currently_facing_downtime: "Serwer jest obecnie niedostępny",
    show_what_you_see: "Pokaż co widzisz",
    by_joining_i_confirm_that_i_have_read_and_understand_the: "Potwierdzam, że zapoznałem się i akceptuję Politykę Prywatności.",
    privacy_policy: "Polityka prywatności",
    invalid_code: "Nieprawidłowy identyfikator sesji",
    code_should_be_of_nine_digits: "Identyfikator sesji powinien składać się z 9 cyfr",
    blitzz: "Blitzz",
    please_enter_your_name: "Proszę podać swoje imię",
    maximum_value_is_30: "Nazwa powinna mieć mniej niż 30 znaków.",
    please_enter_meeting_id: "Proszę wprowadzić swój identyfikator sesji",
    please_try_again: "Spróbuj ponownie.",
    no_one_is_sharing_video: "Nikt nie udostępnia nagrań wideo.",
    retry: "Spróbować ponownie",
    reconnect: "Na nowo połączyć",
    left_the_conversation: "opuścił rozmowę",
    enabled_the_audio: "włączono dźwięk",
    disabled_the_audio: "wyłączono dźwięk",
    enabled_the_video: "włączył wideo",
    disabled_the_video: "wyłączono wideo",
    failed_to_join_room: "Nie udało się dołączyć do pokoju",
    alert: "Alarm",
    override_video_sharing_message: "Czy chcesz zakończyć udostępnianie ekranu i rozpocząć udostępnianie wideo?",
    override_screen_sharing_message: "Czy chcesz zakończyć bieżące udostępnianie ekranu i rozpocząć udostępnianie swojego ekranu?",
    override_video_sharing_with_screen_capturing_message: "Czy chcesz zakończyć bieżące wideo i rozpocząć udostępnianie ekranu?",
    override_screen_sharing_with_video_sharing_message: "Czy chcesz zakończyć udostępnianie ekranu i rozpocząć udostępnianie wideo?",
    yes: "Tak",
    cancel: "Anulować",
    joined_the_call: "dołączył do rozmowy",
    waiting_for_other_members_to_join_the_call: "Czekamy, aż inni członkowie dołączą do rozmowy",
    warning: "Ostrzeżenie",
    camera_permission_disabled: "Brak dostępu do aparatu.",
    microphone_permission_disabled: "Brak dostępu do mikrofonu.",
    location_permission_disabled: "Brak dostępu do lokalizacji.",
    storage_permission_disabled: "Nie można uzyskać dostępu do pamięci masowej",
    permission_error_message_camera: "Proszę włączyć kamerę w ustawieniach urządzenia.",
    permission_error_message_microphone: "Proszę włączyć mikrofon w ustawieniach urządzenia.",
    permission_location_error_message: "Proszę włączyć lokalizację w ustawieniach urządzenia.",
    permission_storage_error_message: "Proszę włączyć przechowywanie danych w ustawieniach urządzenia.",
    give_permission: "Udziel pozwolenia",
    please_wait_for_five_seconds_to_take_screenshot: "Proszę odczekać 5 sekund, aby wykonać kolejne zdjęcie",
    please_wait_for: "Proszę czekać na",
    seconds_to_take_screen_shot: "sekund na zrobienie kolejnego zdjęcia.",
    second_to_take_screen_shot: "sekundę, aby zrobić kolejne zdjęcie.",
    invalid_information_received_from_server: "Otrzymano nieprawidłowe informacje z serwera.",
    unable_to_share_screen_as_no_one_else_has_joined_the_conversation_yet:
        "Nie można udostępnić wideo, ponieważ nikt inny nie dołączył jeszcze do rozmowy",
    successfully_uploaded: "Pomyślnie przesłano",
    disconnected: "Bezładny",
    call_ended_as_no_one_else_had_joined_the_call: "Rozłączono, ponieważ nikt inny nie dołączył.",
    application_update_required: "Wymagana aktualizacja aplikacji",
    update_required_message: "Wygląda na to, że korzystasz ze starszej wersji aplikacji. Zaktualizuj ją w sklepie z aplikacjami.",
    update: "Aktualizacja",
    image_marking_started: "Rozpoczęto oznaczanie obrazu",
    image_marking_stopped: "Zatrzymano oznaczanie obrazu",
    settings: "Ustawienia",
    camera_permission_rationale: "Potrzebujemy dostępu do Twojej kamery. Proszę o zezwolenie na dostęp do kamery.",
    microphone_permission_rationale: "Potrzebujemy dostępu do Twojego mikrofonu. Proszę o zezwolenie na korzystanie z mikrofonu.",
    location_permission_rationale: "Potrzebujemy dostępu do Twojej lokalizacji. Prosimy o zezwolenie na dostęp do lokalizacji.",
    storage_permission_rationale: "Potrzebujemy dostępu do Twojego magazynu. Prosimy o udzielenie pozwolenia na przechowywanie.",
    call_between_two_customers: "Agent nie dołączył, spróbuj ponownie za jakiś czas.",
    media_projection_permission_needed_for_screen_sharing: "Do udostępniania ekranu wymagane jest zezwolenie na wyświetlanie multimediów.",
    poor_network_connection: "Uwaga! Słabe połączenie sieciowe",
    you_are_the_only_person_in_the_call: "Jesteś jedyną osobą biorącą udział w rozmowie",
    image_has_been_captured_and_started_uploading: "Obraz został przechwycony i rozpoczęto przesyłanie",
    version: "Wersja",
    please_enter_the_code_provided_to_you: "Proszę wpisać KOD, który otrzymałeś.",
    start_screen_share: "Udostępnij ekran",
    stop_screen_share: "Zatrzymaj udostępnianie",
    flip_camera: "Kamera obrotowa",
    take_photo: "Zrób zdjęcie",
    flash_off: "Błysk wyłączony",
    flash_on: "Włącz Flasha",
    start_markup: "Rozpocznij znaczniki",
    stop_markup: "Zatrzymaj znaczniki",
    speaker_off: "Głośnik wyłączony",
    speaker_on: "Głośnik włączony",
    more: "Więcej",
    close: "Zamknąć",
    video_off: "Wideo WYŁĄCZONE",
    video_on: "Wideo WŁĄCZONE",
    start_video: "Rozpocznij wideo",
    stop_video: "Zatrzymaj wideo",
    disconnect: "Odłączyć",
    mute: "Niemy",
    muted: "Wyłącz wyciszenie",
    powered_by_blitzz: "Wspierane przez Blitzz",
    connecting_your_call: "Połączono. Czekamy na innych uczestników.",
    connected: "Połączony",
    pin_is_of_nine_digit: "PIN powinien mieć 9 cyfr",
    preparing_image_for_markup: "Przygotowywanie obrazu do znaczników…",
    clear_markup_confirmation: "Czy usunąć znaczniki obrazu od wszystkich użytkowników?",
    clear_markup: "Wyczyść znaczniki",
    clear: "Jasne",
    close_markup: "Zamknij znaczniki",
    end_markup_confirmation: "Czy na pewno chcesz zamknąć znaczniki?",
    end: "Koniec",
    agent_has_ended_markup_cannot_continue_without_agent: "Agent zakończył naliczanie marży. Nie można kontynuować naliczania marży bez agenta.",
    joining_image_markup: "Ładowanie obrazu do oznaczenia…",
    cleared_markup: "Znaczniki obrazów zostały usunięte dla wszystkich użytkowników.",
    capturing_photo: "Robienie zdjęcia…",
    uploading: "Przesyłanie",
    image: "obraz",
    image_ready_for_markup: "Obraz gotowy do oznaczenia.",
    override_video: "To zatrzyma odtwarzanie filmu przez innych. Czy chcesz kontynuować?",
    override_screen_share: "To zatrzyma udostępnianie ekranu innym osobom. Czy chcesz kontynuować?",
    started_screen_share: "Uruchomiono funkcję udostępniania ekranu.",
    stopped_screen_share: "Zatrzymano udostępnianie ekranu.",
    clear_all: "Wyczyść wszystko",
    start_new_call_popup: "Rozpocznij nowe połączenie z KODEM",
    group_call_limit_reached: "Osiągnięto limit połączeń grupowych",
    contact_admin_to_increase_participant_limit: "Poczekaj, aż inny uczestnik się rozłączy i spróbuj ponownie.",
    call_is_being_connected: "Trwa nawiązywanie połączenia. Spróbuj ponownie później.",
    show_recording_for_training_purpose: "Ta sesja jest nagrywana.",
    you_are_sharing_the_screen: "Udostępniasz ekran",
    location_colon: "Lokalizacja:",
    date_colon: "Data:",
    image_for_markup_has_been_downloaded: "Obraz do oznaczenia został pobrany",
    dismiss: "Odrzucać",
    google_play_service_is_not_up_to_date: "Usługa Google Play nie została zaktualizowana",
    rec: "Rec",
    you_are_offline: "Jesteś offline.",
    markup: "Markup",
    exit: "Wyjście",
    video_unsupported: "Wideo nieobsługiwane",
    please_open_this_link_in_safari: "Proszę otworzyć ten link w Safari.",
    you_are_not_able_to_see_this_video: "Nie możesz obejrzeć tego filmu.",
    only_number_Allowed: "Dozwolone są tylko cyfry.",
    permission_warning: "Ostrzeżenie o uprawnieniach",
    unable_to_join_call_please_try_after_sometime: "Nie można dołączyć do rozmowy. Spróbuj ponownie za jakiś czas.",
    share_live_video: "Chcesz udostępnić transmisję na żywo?",
    share_your_screen: "Udostępnić ekran?",
    unable_access_flash: "Nie można uzyskać dostępu do Flash Light.",
    camera_unavailable_try_again: "Kamera jest niedostępna. Spróbuj ponownie.",
    unable_download_image_tomarkup: "Nie można pobrać obrazu z serwera. Spróbuj ponownie.",
    try_again: "Spróbuj ponownie",
    markup_screen_appear_shortly: "Ekran znaczników pojawi się wkrótce...",
    confirm: "Potwierdzać",
    start: "Start",
    could_not_find_endpoint: "Nie można znaleźć punktu końcowego serwera.",
    please_wait: "Proszę czekać...",
    done: "Zrobione",
    ok: "OK",
    please_try_again_with_valid_agent_id: "Spróbuj ponownie, podając prawidłowy identyfikator agenta.",
    meeting_code_not_associated_with_agent: "Identyfikator sesji nie jest powiązany z tym identyfikatorem agenta.",
    powered_by: "Zasilane przez",
    failure: "Awaria",
    code: "Identyfikator sesji",
    start_new_call_question: "Rozpocząć nowe połączenie?",
    stop_sharing: "Przestań udostępniać",
    reconnecting_call: "Ponowne łączenie rozmowy...",
    unable_to_access_mircrophone_or_camera: "Brak dostępu do mikrofonu i kamery.",
    be_sure_to_allow_access_in_browser: "Upewnij się, że ustawienia przeglądarki zezwalają na dostęp.",
    make_sure_you_have_microphone_camera_attached: "Upewnij się, że masz podłączoną kamerę lub mikrofon.",
    location_blocked_by_user: "Lokalizacja zablokowana przez użytkownika",
    user_has_joined_the_call: "Użytkownik dołączył do rozmowy",
    are_you_sure_you_want_to_close_window: "Czy na pewno chcesz zamknąć to okno?",
    reset_guide: "Przewodnik resetowania",
    open_in_google_maps: "Otwórz w Mapach Google",
    location_image_upload_failed: "Nie udało się przesłać obrazu lokalizacji",
    uploading_image: "Przesyłanie obrazu",
    upload_failed: "Przesyłanie nie powiodło się",
    markup_is_in_progress: "Znaczniki są w toku...",
    select_language: "Wybierz język",
    checking_for_extension: "Sprawdzanie rozszerzenia...",
    start_incognito_mode_from_blitzz_screen_share_ext:
        "Aby rozpocząć udostępnianie ekranu w trybie incognito, musisz uruchomić tryb incognito w Blitzz - rozszerzeniu Screen Share w swojej przeglądarce.",
    click_on: "Kliknij na",
    customize_and_control_menu: "Dostosuj i kontroluj menu",
    more_tools: "Więcej narzędzi",
    extensions: "Rozszerzenia",
    click_on_detail: "Kliknij na szczegóły (Blitzz)",
    allow_in_incognito: "Zezwól w trybie incognito.",
    screen_share: "Udostępnij ekran",
    stop_share: "Zatrzymaj udostępnianie",
    save: "Ratować",
    cancel_initcap: "Anulować",
    yes_initcap: "Tak",
    message_title: "Wiadomość",
    device_not_compatible: "Przepraszamy, to urządzenie nie jest kompatybilne.",
    please_download_our_app: "Aby kontynuować, pobierz naszą aplikację.",
    download_app: "Pobierz aplikację",
    this_browser_is_not_supported: "Ta przeglądarka nie jest obecnie obsługiwana.",
    open_in_chrome_or_install_mobile_app:
        "Skopiuj i wklej ten link w najnowszej wersji przeglądarki Google Chrome lub zainstaluj naszą aplikację mobilną i spróbuj ponownie.",
    open_in_safari_or_install_mobile_app:
        "Skopiuj i wklej ten link w najnowszej wersji przeglądarki Safari lub zainstaluj naszą aplikację mobilną i spróbuj ponownie.",
    open_in_chrome_and_try_again: "Otwórz ten link w najnowszej wersji przeglądarki Google Chrome i spróbuj ponownie.",
    okay_initcap: "Dobra",
    would_you_like_to_install_app_or_continue_browser:
        "Czy chcesz zainstalować naszą aplikację, aby dołączyć do spotkania, czy kontynuować za pomocą przeglądarki?",
    continue_initcap: "Kontynuować",
    webview_limited_support_message: "Aby uzyskać najlepsze rezultaty, otwórz witrynę w przeglądarce Chrome lub w przeglądarce domyślnej.",
    continue_anyway: "Kontynuuj mimo wszystko",
    open_in_browser: "Otwórz w przeglądarce",
    link_copied_open_in_browser: "Link skopiowany! Jeśli przeglądarka się nie otworzyła, wklej link w Chrome.",
    add_blitzz_extension_to_screen_share: "Dodaj rozszerzenie Blitzz do udostępniania ekranu",
    add_to_chrome_and_confirm: "„Dodaj do Chrome i potwierdź”",
    add_extension: "Dodaj rozszerzenie",
    permission_error_message_camera_browser: "Proszę włączyć kamerę w ustawieniach przeglądarki.",
    camera_not_found: "Nie znaleziono aparatu",
    enable_camera_and_reconnect_call: "Musisz włączyć kamerę, odświeżyć stronę i nawiązać połączenie.",
    permission_error_message_microphone_browser: "Proszę włączyć mikrofon w ustawieniach przeglądarki.",
    permission_error_message_location_browser: "Proszę włączyć lokalizację w ustawieniach przeglądarki.",
    microphone_not_found: "Nie znaleziono mikrofonu",
    enable_microphone_and_reconnect_call: "Musisz włączyć mikrofon, odświeżyć stronę i nawiązać połączenie.",
    download_failed: "Pobieranie nie powiodło się",
    continue_markup: "Kontynuuj znaczniki",
    save_and_exit: "Zapisz i wyjdź z funkcji Markup",
    exit_markup: "Wyjście znacznika",
    you_are_recording_the_conversation: "Nagrywasz teraz rozmowę.",
    make_sure_participant_know_they_are_being_recorded: "Upewnij się, że uczestnicy wiedzą, że są nagrywani.",
    you_can_download_recordings_later: "Nagrany plik możesz później pobrać.",
    share_without_joining_session_lanuch_showme_enter_code:
        "Nie można udostępnić ekranu bez dołączenia do sesji ShowMe. Uruchom ShowMe by Blitzz i wprowadź otrzymany identyfikator sesji.",
    call_limit_reach_contact_Admin_to_increase_limit:
        "Osiągnięto limit połączeń grupowych. Skontaktuj się z administratorem, aby zwiększyć limit uczestników lub poczekaj, aż ktoś opuści sesję.",
    other_user_trying_share_screen_Video: "Inny użytkownik próbuje udostępnić ekran lub wideo",
    call_has_ended: "Połączenie zakończone",
    would_you_like_to_save_image: "Czy chcesz zapisać obraz?",
    audio_unsupported: "Dźwięk nieobsługiwany",
    please_install_our_app_to_continue: "Aby kontynuować, zainstaluj naszą aplikację.",
    unable_to_play_remote_audio: "Nie można odtworzyć dźwięku zdalnie.",
    unable_to_playback_audio: "Nie można odtworzyć dźwięku.",
    unable_to_play_video: "Nie można odtworzyć wideo.",
    unable_to_playback_video: "Nie można odtworzyć wideo.",
    okay_cap: "Dobra",
    pre_call_test: "Test przed rozmową",
    language: "Język",
    reset: "Nastawić",
    zoom_in: "Powiększ",
    zoom_out: "Oddal",
    headset: "Zestaw słuchawkowy",
    bluetooth: "Bluetooth",
    live_pointer_enabled_message: "Uruchomiono wskaźnik na żywo. Możesz przesuwać wskaźnik, przeciągając go.",
    speaker: "Głośnik",
    live_pointer_disabled_message: "Zatrzymany wskaźnik na żywo",
    pointer: "Wskaźnik",
    network_quality: "Jakość sieci",
    participant: "Uczestnik",
    you: "(Ty)",
    reconnecting: "Ponowne łączenie",
    very_bad: "Bardzo źle",
    bad: "Zły",
    poor: "Słaby",
    good: "Dobry",
    excellent: "Doskonały",
    loc: "Lokalny",
    expand: "Zwiększać",
    collapse: "Zawalić się",
    network: "Sieć",
    ocr_inprogress: "Trwa rozpoznawanie znaków (OCR).",
    select_area_extract_text: "Wybierz obszar, aby wyodrębnić tekst",
    text_copied: "Tekst skopiowany",
    extract_text_from_image: "Wyodrębnianie tekstu z obrazu...",
    not_extract_text_from_image: "Nie można wyodrębnić tekstu z obrazka. ",
    try_again_clear_image_or_reselect_region: "Spróbuj ponownie, używając wyraźnego obrazu lub ponownie wybierz region ekstrakcji.",
    error: "Błąd ",
    occured_while_receiving_doc: " wystąpiło podczas odbioru dokumentu.",
    return_to_video: "Powrót do wideo",
    save_entire_image: "Zapisz całość",
    save_cropped_image: "Zapisz przycięte",
    text_copied_to_clipboard: "Kliknij, aby skopiować",
    extract_text: "Wyodrębnij tekst",
    stop_pointer: "Zatrzymaj wskaźnik",
    do_not_rotate_the_phone_live_pointer_message: "Aby uzyskać lepsze wrażenia wizualne, nie obracaj urządzenia, gdy włączony jest wskaźnik na żywo.",
    got_it_btn: "Zrozumiałem!",
    speed_test: "Test prędkości",
    duration: "Czas trwania",
    preparing_image_for_OCR: "Przygotowanie obrazu do przetwarzania tekstu…",
    agent_extract_text_from_image: "Proszę czekać, Agent wyodrębnia tekst z przechwyconego obrazu.",
    unable_download_image_to_ocr: "Nie można pobrać obrazu w celu przetworzenia. Spróbuj ponownie.",
    selected_area_is_small: "Wybrany obszar jest zbyt mały,",
    please_select_large_area: " Proszę zaznaczyć większy fragment obrazu.",
    zoom_level: "Poziom powiększenia",
    do_not_rotate_the_phone_markup_message: "Aby zapewnić lepsze wrażenia wizualne, nie obracaj urządzenia, gdy znaczniki są włączone.",
    capturing: "Przechwytywanie...",
    upload_completed: "Przesyłanie zakończone",
    network_quality_not_available: "Jakość sieci niedostępna",
    not_able_to_see_your_stream: "nie będzie można zobaczyć Twojego strumienia",
    device_not_supported: "Urządzenie nie jest obsługiwane.",
    video_settings_need_to_be_configured_by_admin_web:
        "Aby to urządzenie działało, administrator musi skonfigurować ustawienia wideo. Skontaktuj się z administratorem firmy lub wyślij wiadomość e-mail.",
    contact: "Kontakt",
    video_paused_by_agent: "Wideo wstrzymane przez agenta",
    not_shared: "Nie udostępniane",
    network_type: "Typ sieci",
    image_thumb_caption: "Obraz",
    saved_images: "Zapisane obrazy",
    update_your_browser_to_share_your_screen: "Zaktualizuj przeglądarkę do najnowszej wersji, aby udostępnić ekran",
    try_these_option_to_have_better_experience: "Wypróbuj jedną z tych opcji, aby uzyskać lepsze wrażenia.",
    some_features_are_not_supported_in_this_browser: "Niektóre funkcje nie są obsługiwane w tej przeglądarce.",
    unsupported_browser: "Nieobsługiwana przeglądarka",
    permission_message_for_screenshare:
        "Uprawnienia dostępu do obszaru ekranu zostały odrzucone lub bieżąca instancja przeglądarki nie ma uprawnień dostępu do udostępniania ekranu.",
    go_to_system_preferences: "Przejdź do Preferencji systemowych",
    security_privacy: "Bezpieczeństwo i prywatność",
    select_privacy_tab: "Wybierz kartę Prywatność",
    screen_recording: "Nagrywanie ekranu",
    select_your_browser: "Wybierz swoją przeglądarkę",
    use_chrome_to_share_your_screen: "Użyj przeglądarki Chrome lub Firefox, aby udostępnić ekran",
    there_was_an_error_trying_to_share_your_video: "Wystąpił błąd podczas próby udostępnienia filmu.",
    please_stop_video_and_start_video_again_to_resume: "Proszę zatrzymać film i uruchomić go ponownie, aby wznowić odtwarzanie.",
    decline: "Spadek",
    agree: "Zgadzać się",
    click_the_padlock: "Kliknij kłódkę",
    to_the_left_of_a_web_page_address: "po lewej stronie paska adresu.",
    clear_blocked_permission_for_share_the_screen: "Wyczyść wszelkie zablokowane uprawnienia do udostępniania ekranu w sekcji uprawnień.",
    tips_colon: "Porady:",
    your_internet_connection_is_unstable: "Twoje połączenie internetowe jest niestabilne",
    participants_connection_unstable: "Połączenie internetowe uczestnika <participantNum> jest niestabilne",
    enter_text_here: "Wpisz tutaj tekst",
    text: "Tekst",
    rect: "Prostokąt",
    draw: "Rysować",
    try_our_mobile_app: "Otwórz w aplikacji",
    still_facing_issue_connect_mobile_app: "Jeśli problem nadal występuje, skontaktuj się z nami za pomocą naszej aplikacji mobilnej.",
    open_in_app: "Otwórz w aplikacji",
    enable_microphone_from_browser_settings: "Włącz mikrofon w ustawieniach przeglądarki.",
    enable_camera_from_browser_settings: "Włącz kamerę w ustawieniach przeglądarki.",
    unable_to_access_microphone: "Nie można uzyskać dostępu do mikrofonu",
    participants_title: "Uczestnicy",
    bookmarks_title: "Zakładki",
    search_or_add_new_bookmark: "Wyszukaj lub dodaj nową zakładkę",
    create_new_bookmark: "Utwórz nową zakładkę",
    press_enter_or_click_on_create_new_bookmark: "Naciśnij Enter lub kliknij Utwórz nową zakładkę, aby dodać nową zakładkę",
    tap_retry_to_load: "Kliknij Ponów, aby załadować",
    bookmark_saved_with_image: "Dodaj zakładkę do zakładek wraz z obrazkiem.",
    bookmark_saved: "Zakładka zapisana.",
    bookmark_added: "Dodano zakładkę.",
    failed_to_bookmark_please_try_again: "Nie udało się dodać do zakładek. Spróbuj ponownie.",
    special_characters_are_not_allowed: "Znaki specjalne nie są dozwolone.",
    home_screen: "Ekran główny",
    privacy_policy_popup_text_description:
        "Rozumiem i zgadzam się na dobrowolne użycie mojej kamery do udostępnienia widoku mojego otoczenia w celu rozwiązania moich problemów technicznych. Rozumiem, że nie będzie tworzone ani przechowywane żadne nagranie. Mogę w dowolnym momencie wyłączyć funkcję udostępniania. Nie będę kierować kamery na obszary, osoby ani przedmioty, których obrazu nie chcę udostępniać. Potwierdzam również, że zapoznałem się z Polityką Prywatności i ją akceptuję.",
    audio_issue_ios: "Problem z dźwiękiem?",
    toggle_mic_icon_guest_msg: "Przełącz czerwoną ikonę mikrofonu/kamery powyżej lub skorzystaj z dźwięku z połączenia telefonicznego (PSTN).",
    toggle_mic_icon_agent_msg:
        "Poproś użytkownika systemu iOS o przełączenie czerwonej ikony mikrofonu/kamery powyżej lub skorzystanie z dźwięku z połączenia telefonicznego (PSTN).",
    audio_ios_msg_read_more: "Przeczytaj więcej",
    error_occured_in_processing_the_request: "Wystąpił błąd podczas przetwarzania żądania. Spróbuj ponownie.",
    markup_ocr_upload_timeout: "Trwa dłużej niż zwykle.",
    markup_cancelled: "Markup anulowany",
    ocr_cancelled: "Wyciąg z tekstu anulowany",
    click_here: "Kliknij tutaj",
    to_return_to_video_and_try_again: "aby powrócić do opcji Wideo i spróbować ponownie.",
    test_connection: "Połączenie testowe",
    markup_exit: "zatrzymano Markup",
    ocr_exit: "zatrzymano Wyodrębnij tekst",
    camera: "Kamera",
    camera_blocked: "Kamera zablokowana",
    microphone: "Mikrofon",
    microphone_blocked: "Zablokowany mikrofon",
    speakers: "Głośniki",
    speakers_blocked: "Zablokowane głośniki",
    grant_permission: "Udziel pozwolenia",
    play_test_sound: "Odtwórz dźwięk testowy",
    call_settings: "Ustawienia połączeń",
    allow_access_to_camera: "Zezwól na dostęp do swojej kamery.",
    allow_access_to_mic: "Zezwól na dostęp do mikrofonu.",
    default_label: "Domyślny",
    do_not_rotate_the_phone_OCR_message: "Aby zapewnić lepsze wrażenia wizualne, nie obracaj urządzenia, gdy opcja Wyodrębnij tekst jest włączona.",
    browser_not_supported: "Przeglądarka nie jest obsługiwana",
    your_browser_not_support_video: "Twoja przeglądarka nie obsługuje połączeń wideo.",
    open_link_in_google_samsung_browser:
        "Skopiuj i wklej ten link w najnowszej wersji przeglądarki Google Chrome lub przeglądarki internetowej Samsung.",
    open_link_in_safari_browser: "Skopiuj i wklej ten link w najnowszej wersji przeglądarki Safari.",
    copy_link: "Kopiuj link",
    copy_code: "Kopiuj kod",
    session_code_copy: "Identyfikator sesji skopiowany do schowka.",
    meeting_code_lable: "Kod spotkania",
    add_participant_lable: "Dodaj uczestnika",
    send_this_link_to_guest: "Wyślij ten link gościowi",
    send_an_email: "wysłać e-mail",
    or_label: "Lub",
    remote_mic_cam_error: "Mikrofon/kamera uczestnika zdalnego ma błąd.",
    device_not_supported_or_permi_block: "Albo ich urządzenie nie jest obsługiwane, albo mają zablokowane uprawnienia.",
    remote_participant: "Uczestnik zdalny",
    microphone_unmuted: "Mikrofon wyciszony",
    microphone_muted: "Mikrofon wyciszony",
    camera_on: "Kamera włączona",
    camera_off: "Wyłączona kamera",
    error_label: "błąd",
    cannot_start_video: "Nie można uruchomić wideo",
    failed_to_start_video_camera: "Nie udało się uruchomić kamery wideo.",
    please_select_another_camera_from_call_settings: "Wybierz inną kamerę wideo w Ustawieniach połączeń.",
    please_select_another_video_camera: "Proszę wybrać inną kamerę wideo.",
    chat: "Pogawędzić",
    chat_info:
        "Wiadomości czatu są widoczne dla wszystkich uczestników rozmowy. Historia czatu zniknie na stałe po rozłączeniu, zgodnie z założeniami.",
    chat_input_placeholder: "Wpisz wiadomość",
    participant_connected: "<participantCount> połączonych uczestników",
    click_to_share_invite: "Kliknij, aby udostępnić zaproszenie",
    remote_flashlight_not_supported_on_guest_device_or_not_ready: "Zdalna latarka nie jest obsługiwana na urządzeniu gościa lub nie jest gotowa",
    pin_a_video_tile_above_to_use_this_feature: "Przypnij kafelek wideo powyżej, aby skorzystać z tej funkcji",
    pin_video_for_all_participants: "Przypnij wideo dla wszystkich uczestników",
    return_to_gallery_view: "Powrót do widoku galerii",
    override_own_screen_share: "Udostępnianie ekranu zostanie zatrzymane. Czy chcesz kontynuować?",
    override_own_video: "Twój film zostanie zatrzymany. Czy chcesz kontynuować?",
    blur: "Plama",
    mask_lable: "Maska",
    arrow: "Strzałka",
    view_text: "Pogląd",
    recording_stopped: "Nagrywanie zatrzymane",
    error_recording_please_try_again: "Błąd nagrywania, spróbuj ponownie",
    error_recording_wait_or_disconnect_call:
        "Błąd nagrywania. Poczekaj, aż gospodarz zakończy nagrywanie, albo rozłącz się i dołącz ponownie później.",
    wait_for_recording: "Proszę czekać, rozpoczynamy nagrywanie...",
    max_participant_limit_for_recording:
        "Osiągnięto limit uczestników podczas nagrywania. Poczekaj, aż gospodarz zakończy nagrywanie, lub rozłącz się i dołącz ponownie później.",
    error_recording_all_participants: "Błąd podczas rejestrowania wszystkich uczestników. ",
    please_stop_and_restart_recording: "Proszę zatrzymać nagrywanie i wznowić je.",
    some_participants_will_not_be_recorded: "Niektórzy uczestnicy nie zostaną zarejestrowani.",
    participant_limit_reached: "Osiągnięto limit uczestników.",
    your_account_has_4_participant_limit_while_recording: "Podczas nagrywania na Twoim koncie może uczestniczyć maksymalnie 4 osoby.",
    disconnect_call: "Rozłącz połączenie",
    record_title: "Nagrywać",
    stop_recording_btn: "Zatrzymaj nagrywanie",
    back_to: "Powrót do",
    cam_per_denied_msg: "Jeden z uczestników mógł zablokować dostęp do kamery na swoim urządzeniu. Aby mu pomóc, zobacz",
    mic_per_denied_msg: "Jeden z uczestników mógł zablokować dostęp do mikrofonu na swoim urządzeniu. Aby mu pomóc, zobacz",
    cam_mic_per_denied_msg: "Jeden z uczestników mógł zablokować dostęp do kamery i mikrofonu na swoim urządzeniu. Aby mu pomóc, zobacz",
    per_denied_common_msg: "aby uzyskać szybkie wskazówki dotyczące resetowania uprawnień przeglądarki.",
    your_camera_block: "Twoja kamera jest zablokowana",
    your_microphone_block: "Twój mikrofon jest zablokowany",
    your_location_block: "Twoja lokalizacja jest zablokowana",
    we_cannot_access_your_camera: "Nie mamy dostępu do Twojej kamery.",
    we_cannot_access_your_microphone: "Nie mamy dostępu do Twojego mikrofonu.",
    we_cannot_access_your_location: "Nie mamy dostępu do Twojej lokalizacji.",
    go_to_browser_settings: "Aby przyznać dostęp, przejdź do ustawień przeglądarki, a następnie kliknij tutaj, aby ponownie załadować stronę.",
    still_facing_issue: "Nadal masz problem?",
    try_the: "Wypróbuj",
    mobile_app: "aplikacja mobilna",
    view_help_article: "Wyświetl artykuł pomocy",
    enable_or_attach_camera_and_reconnect_call: "Należy włączyć lub podłączyć kamerę, odświeżyć stronę i nawiązać połączenie.",
    enable_or_attach_microphone_and_reconnect_call: "Należy włączyć lub podłączyć mikrofon, przeładować stronę i ponownie nawiązać połączenie.",
    start_rec_label: "Rozpocznij nagrywanie.",
    stop_rec_label: "Zatrzymaj nagrywanie.",
    start_recording_tooltip_label: "Rozpocznij nagrywanie",
    click_here_label: "Kliknij tutaj",
    cam_per_denied_title: "Zablokowana kamera uczestnika zdalnego",
    mic_per_denied_title: "Zablokowany mikrofon uczestnika zdalnego",
    cam_mic_per_denied_title: "Zablokowana kamera i mikrofon uczestnika zdalnego",
    these_instructions: "te instrukcje",
    Whisper_on: "Szept dalej",
    Whisper_off: "Szept",
    enable_whisper_tooltip_label: "Włącz szept, aby porozmawiać z gospodarzem",
    host_can_hear_you_now: "Gospodarz może cię teraz słyszeć",
    mediate_lable: "Pośredniczyć",
    join_call_as_participant: "Dołącz do rozmowy jako uczestnik",
    observer_lable: "Obserwator",
    silent_observer_connect_alert_popup: "Połączono jako obserwator. Twój mikrofon i kamera są wyciszone.",
    click_mediate_if_you_would_like_to_join_as_a_participant: "Kliknij „Mediuj”, jeśli chcesz dołączyć jako uczestnik.",
    guest_lable: "Gość",
    Silent_observer_lable: "Cichy obserwator",
    invite_participant_tooltip_lable: "Mikrofon i kamera zostaną wyciszone podczas sesji Silent Observer i nie będą widoczne dla uczestników-gości.",
    send_link_silent_observer: "Wyślij ten link do silent observer.",
    join_as_mediator_title: "Dołącz jako Mediator?",
    join_as_mediator_popup_description:
        "Czy na pewno chcesz dołączyć do rozmowy jako uczestnik? Kliknij „Potwierdź” poniżej, a następnie kliknij „Połącz” na następnym ekranie, aby dołączyć jako uczestnik (mediator).",
    from_participant: "Od uczestnika",
    download_key: "Pobierać",
    download_not_supported_text: "Twoje urządzenie nie obsługuje pobierania.",
    undo: "Anulować",
    redo: "Przerobić",
    color_label: "Kolor",
    overall_experience: "Ogólne wrażenia?",
    leave_comment: "Zostaw komentarz (opcjonalnie)",
    sent: "Wysłano",
    send: "Wysłać",
    view_unavailable: "Widok niedostępny",
    whisper_label: "Szept",
    thanks: "Dzięki!",
    stop_recording_tooltip_label: "Aby zatrzymać nagrywanie, wróć do trybu galerii.",
    save_image: "Zapisz obraz",
    screenshare_mweb_text: "Udostępnianie ekranu z urządzenia wymaga aplikacji. Połącz tę sesję z aplikacją mobilną.",
    disconnect_and_launchapp_btn: "Odłącz i uruchom aplikację",
    device_battery_low: "Niski poziom naładowania baterii urządzenia",
    batteryinfo_tooltip: "Informacje o baterii urządzenia",
    notes_lable: "Notatki",
    new_note_lable: "Nowa notatka",
    only_visible_to_you: "Widoczne tylko dla Ciebie",
    empty_note: "Pusta notatka",
    title_lable: "Tytuł",
    delete_lable: "Usuwać",
    delete_Note: "Usuń notatkę",
    want_delete_this_note: "Czy na pewno chcesz usunąć tę notatkę?",
    failed_delete_note: "Nie udało się usunąć notatki.",
    note_deleted_successfully: "Uwaga usunięta",
    failed_edit_note: "Nie udało się edytować notatki.",
    note_edited_successfully: "Notatka zaktualizowana",
    failed_add_note: "Nie udało się dodać notatki.",
    note_added_successfully: "Dodano notatkę",
    screenshare_mweb_title: "Wymagane pobranie aplikacji",
    screenshare_mweb_desc1: "Aby udostępnić ekran swojego urządzenia, wymagana jest aplikacja.",
    screenshare_mweb_desc2: "aby pobrać aplikację.",
    upcoming_event: "Nadchodzące wydarzenie",
    scheduled_to_start_in: "Rozpoczęcie planowane jest na",
    please_wait_for_the_host_to_start_this_event: "Poczekaj, aż gospodarz rozpocznie to wydarzenie i spróbuj ponownie.",
    image_deleted: "Obraz usunięty",
    failed_to_delete_image: "Nie udało się usunąć obrazu",
    are_you_sure_you_want_to_delete_image: "Czy na pewno chcesz trwale usunąć ten obraz?",
    delete_image_title: "Usuń obraz",
    location_image_thumb_caption: "Obraz lokalizacji",
    schedule_to_start_in_a_few_seconds: "Rozpoczęcie zaplanowano za kilka sekund.",
    edit_label: "Redagować",
    scan_code_lable: "Zeskanuj kod",
    scan_code_result: "Wynik skanowania kodu",
    extract_text_result: "Wyodrębnij wynik tekstowy",
    scan_code_result_not_found: "Nie udało się zeskanować kodu QR/kodu kreskowego z obrazka. Spróbuj ponownie z wyraźnym obrazkiem.",
    host_features_will_not_be_available_when_using_app: "Funkcje hosta nie będą dostępne podczas korzystania z aplikacji",
    note_colon: "Notatka:",
    leave_lable: "Wyjechać",
    are_you_sure_you_want_to_leave_this_call: "Czy na pewno chcesz opuścić tę rozmowę?",
    supported_browser_versions: "Obsługiwane wersje przeglądarek",
    see: "Widzieć",
    has_sent_you_link_for_video_conference: "<company_name> wysłał Ci link do wideokonferencji na żywo.",
    join_the_session: "Dołącz do sesji",
    other: "Inny",
    share_invitation_with_others: "Udostępnij zaproszenie na sesję innym osobom",
    copy_invitation: "Kopiuj zaproszenie",
    copy_invitation_desc: "Skopiuj tekst zaproszenia wraz z zaplanowanym czasem i wyślij go ręcznie",
    copied: "Skopiowano!",
    copy_session_code: "Kopiuj identyfikator sesji",
    copy_link_to_share: "Kopiuj link, aby udostępnić",
    reference: "Odniesienie",
    session_invitation_copied: "Zaproszenie na sesję skopiowane do schowka.",
    guest_url_copy: "Adres URL gościa został skopiowany do schowka.",
    observer_url_copied: "Adres URL obserwatora został skopiowany do schowka.",
    sms_sent_label: "SMS wysłany!",
    email_sent_label: "E-mail wysłany!",
    invite_sent_successfully: "Zaproszenie zostało pomyślnie wysłane",
    sms_label: "SMS",
    copy: "Kopia",
    email: "E-mail",
    enter_valid_email: "Podaj prawidłowy adres e-mail.",
    limit_exceeded: "Przekroczono limit",
    enter_email_send: "Wprowadź adres e-mail, aby wysłać zaproszenie",
    send_invitaion_lable: "Wyślij zaproszenie",
    enter_mobile_number_lable: "Wprowadź numer telefonu komórkowego",
    enter_valid_mobile: "Wprowadź prawidłowy numer telefonu komórkowego.",
    new_email_address: "Adres e-mail",
    mobile_number: "Numer telefonu komórkowego",
    video_quality: "Jakość wideo",
    low_bandwidth: "Niska przepustowość",
    adaptive: "Adaptacyjny",
    high_quality: "Wysoka jakość",
    wait_for_the_call_to_start: "Poczekaj na rozpoczęcie połączenia",
    call_disconnected: "Połączenie rozłączone",
    dont_show_this_again: "Nie pokazuj tego ponownie",
    invite_participant_lable: "Zaproś uczestnika",
    saved_label: "Zapisane!",
    show_stream: "Pokazywać",
    hide_stream: "Ukrywać",
    camera_permission_required_title: "Wymagane pozwolenie na fotografowanie",
    camera_permission_required_disc1: "Aby udostępnić transmisję wideo na żywo, włącz uprawnienia kamery w ustawieniach przeglądarki, a następnie ",
    reload_page_disc: "Aby przeładować stronę.",
    location_permission_required_title: "Wymagane pozwolenie na lokalizację",
    microphone_permission_required_title: "Wymagane pozwolenie na korzystanie z mikrofonu",
    confirmation_lable: "Potwierdzam, że przeczytałem i akceptuję",
    live_location: "Lokalizacja na żywo",
    no_one_shared_location: "Nikt nie udostępnił swojej lokalizacji",
    it_was_great_lable: "Było wspaniale",
    not_so_great_lable: "Nie tak świetnie",
    link_copied: "Link skopiowany",
    microphone_publication_description: "Nie znaleziono mikrofonu lub może być on używany przez inną aplikację.",
    please_close_all_other_application: "Zamknij wszystkie inne aplikacje, które mogą korzystać z mikrofonu i spróbuj ponownie.",
    app_to_share_your_device_screen: "Kontynuuj połączenie w aplikacji, aby udostępnić ekran swojego urządzenia",
    launch_app: "Uruchom aplikację",
    screen_share_requires_app: "Do udostępniania ekranu wymagana jest aplikacja.",
    only_takes_few_seconds: "Zajmie Ci to tylko kilka sekund.",
    download_app_from_app_store_and_then_return_page: "Pobierz aplikację ze sklepu App Store i wróć na tę stronę.",
    click_to_download_app: "Kliknij, aby pobrać aplikację",
    go_to_Step_2: "Jeśli pobrałeś już aplikację, przejdź do kroku 2",
    next_lable: "Następny",
    rejoin_the_call_in_app: "Dołącz ponownie do rozmowy w aplikacji",
    step2_screen_share_description:
        "Po pobraniu aplikacji możesz ponownie dołączyć do rozmowy w aplikacji i wybrać opcję „Udostępnij ekran”, aby udostępnić ekran swojego urządzenia mobilnego.",
    disconnect_the_call_in_browser: "Spowoduje to rozłączenie połączenia w przeglądarce",
    back_btn_lable: "Z powrotem",
    rejoin_call_in_app: "Ponowne dołączenie do rozmowy w aplikacji",
    step_one: "Krok 1",
    step_two: "Krok 2",
    beta_release_tag_des1: "Ta funkcja jest obecnie dostępna w wersji beta.",
    email_support_feedback: "Jeśli chcesz podzielić się swoją opinią, wyślij wiadomość e-mail na adres support@blitzz.co.",
    would_you_like_to_exit_markup: "Czy chcesz wyjść z funkcji znaczników?",
    current_position: "Aktualna pozycja",
    start_point: "Punkt początkowy",
    live_captions: "Napisy na żywo",
    starting_label: "Startowy...",
    live_captions_started: "Rozpoczęto korzystanie z napisów na żywo.",
    spoken_language_is_set_to_english: "Językiem mówionym jest angielski.",
    click_to_open_more_information: "Kliknij, aby otworzyć więcej informacji",
    open_in_safari_chrome_or_install_mobile_app:
        "Skopiuj i wklej ten link w najnowszej wersji przeglądarki Safari lub Google Chrome albo zainstaluj naszą aplikację mobilną i spróbuj ponownie.",
    continue_without_name: "Kontynuuj bez nazwy",
    enter_your_name: "Wpisz swoje imię",
    ignore: "Ignorować",
    screen_share_info:
        "Aby uniknąć efektu nieskończonego lustra, nie udostępniaj całego ekranu ani okna przeglądarki. Zamiast tego udostępnij tylko jedną kartę lub inne okno.",
    screen_share_to_everyone: "Udostępniasz ekran wszystkim",
    stop_share_screen: "Zatrzymaj udostępnianie ekranu",
    unable_to_start_the_video_please_download_the_app_to_continue: "Nie można uruchomić filmu. Aby kontynuować, pobierz aplikację.",
    upload: "Wgrywać",
    from_device: "Z urządzenia",
    from_camera: "Z aparatu",
    upload_failed_files: "Prześlij nieudane pliki",
    uploaded_max_file: "Przesłano maksymalną dozwoloną liczbę plików.",
    upload_files: "Prześlij pliki",
    upload_limit_reached: "Osiągnięto limit przesyłania",
    drop_for_upload_or_select: "Upuść tutaj, aby przesłać lub wybierz",
    upload_20_file: "Możesz przesłać maksymalnie 20 plików na raz.",
    max_size_20MB: "Maksymalny rozmiar pliku <fileSize> MB.",
    cancel_upload: "Anuluj przesyłanie",
    cancel_upload_alert: "Anulować przesyłanie?",
    file_details_deleted: "Wszystkie szczegóły dodane do plików zostaną usunięte.",
    uploaded_files: "Przesłane pliki",
    capture_image: "Przechwyć obraz",
    participant_uploading_file_msg: "Poczekaj, aż drugi uczestnik prześle pliki.",
    previous: "Poprzedni",
    max_file_count: "Jednorazowo możesz przesłać maksymalnie <fileCount> plików.",
    removed_more_than_20MB_file: "Pliki większe niż <fileSize> MB są usuwane.",
    uploading_files: "Przesyłanie plików",
    upload_failed_file_count: "Nie udało się przesłać: <numberOfFailedFiles> plików nie zostało przesłanych.",
    add_caption: "Dodaj podpis...",
    uploaded_files_of_a_maximum: "Przesłano <successCount> plików, z maksymalnej liczby <totalCount>",
    you_have_selected_the_maximum_number_of_files_allowed: "Wybrano maksymalną dozwoloną liczbę plików.",
    upload_max_count: "Prześlij maksymalnie <remainingCount> plików.",
    image_upload_msg: "Proszę czekać, aż zdjęcia zostaną przesłane",
    finished_uploading: "Zakończono przesyłanie",
    upload_files_msg: "Prześlij pliki",
    uploading_dots: "Przesyłanie…",
    loading_image_counter: "Ładowanie obrazu <counter> z <totalCount>",
    closing_tab: "Zamykanie karty",
    close_tab: "Zamknij kartę",
    return_to_home_screen: "Powrót do ekranu głównego",
    session_code_expire_msg: "Ten link został zamknięty",
    view_call_logs: "Wyświetl dzienniki połączeń",
    measurements: "Pomiary",
    copy_all: "Kopiuj wszystko",
    measure: "Mierzyć",
    view_supported_device: "Wyświetl obsługiwane urządzenia",
    device_not_support_google_play_service: "Urządzenie uczestnika nie obsługuje usługi Google Play, która jest wymagana do pomiarów 3D",
    device_not_compatible_for_measurement: "Urządzenie nie jest kompatybilne z pomiarem",
    device_required_update_google_play_service: "Aby rozpocząć pomiary 3D, urządzenie uczestnika wymaga aktualizacji usługi Google Play.",
    device_required_google_play_service: "Aby rozpocząć pomiary 3D, na urządzeniu uczestnika wymagana jest instalacja usługi Google Play",
    app_required_update_for_measurement: "Do pomiaru wymagana jest aktualizacja aplikacji pomocniczej",
    app_required_for_measurement: "Do pomiaru wymagana jest aplikacja pomocnicza",
    preparing_ar_measurement: "Przygotowywanie widoku do pomiaru...",
    measurement_copied_msg: "Pomiary skopiowane do schowka",
    ready_for_measurement: "Gotowy do pomiaru",
    move_device_to_start: "Przesuń urządzenie, aby rozpocząć",
    tacking_not_available: "Śledzenie nie jest dostępne",
    camera_use_bu_another_app: "Aparat jest używany przez inną aplikację",
    more_light_required: "Potrzeba więcej światła",
    move_further_away: "Odsuń się dalej",
    slow_down: "Kierowco zwolnij",
    measurement_cancelled: "Pomiar anulowany",
    app_required: "Aby skorzystać z tej funkcji, należy pobrać aplikację. <learnmore>",
    learn_more: "Dowiedz się więcej",
    ar_measurement_description_step2:
        "Po pobraniu aplikacji możesz ponownie dołączyć do rozmowy w aplikacji i wybrać opcję „Pomiar”, aby rozpocząć pomiar rzeczywistości rozszerzonej",
    ar_measurement_description_step1: "Funkcja pomiaru rzeczywistości rozszerzonej umożliwia pomiar obiektów w 3D i wymaga pobrania aplikacji",
    app_to_support_ar_measurement: "Kontynuuj to połączenie w aplikacji, aby wesprzeć pomiary AR",
    find_surface_to_measure: "Znajdź pobliską powierzchnię do pomiaru",
    measurement_toast_note_to_guide_user: "Uwaga: Pomiary są przybliżone.",
    measurement_toast_msg_to_guide_user:
        "Aby uzyskać najlepsze rezultaty, użyj funkcji Measure (Mierz) na wyraźnie określonych obiektach znajdujących się w odległości od 0,5 do 3 metrów (od 2 do 10 stóp) od telefonu.",
    having_audio_issue: "Masz problem z dźwiękiem?",
    remote_participant_voice_not_coming_description:
        "Wygląda na to, że masz trudności ze słyszeniem głosu innych uczestników lub obecnie występuje jakiś problem z dźwiękiem.",
    workaround_action_for_remote_audio_not_coming: "<click_here> aby zastosować szybkie obejście problemu.",
    click_here_for_audio_label: "Kliknij tutaj",
    measurement_copyall_msg: "Pomiar(y) skopiowane do schowka",
    armarkup_cancelled: "Anulowano narzut AR",
    device_not_support_google_play_service_for_markup:
        "Urządzenie uczestnika nie obsługuje usługi Google Play, która jest wymagana do obsługi znaczników 3D",
    device_required_update_google_play_service_for_markup:
        "Aby rozpocząć korzystanie z funkcji 3D Markup, urządzenie uczestnika wymaga aktualizacji usługi Google Play.",
    device_required_google_play_service_for_markup:
        "Aby rozpocząć korzystanie z funkcji 3D Markup, na urządzeniu uczestnika wymagana jest instalacja usługi Google Play",
    device_not_compatible_for_AR_Markup: "Urządzenie nie jest kompatybilne z funkcją AR Markup",
    app_required_update_for_AR_Markup: "Do obsługi funkcji AR Markup wymagana jest aktualizacja aplikacji pomocniczej",
    app_required_for_AR_Markup: "Do obsługi znaczników AR wymagana jest aplikacja pomocnicza",
    preparing_view_for_ar_markup: "Przygotowywanie widoku do AR Markup...",
    AR_Markup_Lable: "Markup AR",
    armarkup_toast_msg_to_guide_user:
        "Aby uzyskać najlepsze efekty, używaj funkcji Markup na wyraźnie określonych obiektach znajdujących się w odległości od 0,5 do 3 metrów (od 2 do 10 stóp) od telefonu.",
    ar_live_streaming_ready_to_markup: "Transmisja strumieniowa AR na żywo gotowa do oznaczenia.",
    ar_markups_cleared_for_all_users: "Znaczniki AR zostały usunięte dla wszystkich użytkowników.",
    ar_live_streaming_marking_stopped: "Zatrzymano oznaczanie transmisji strumieniowej AR na żywo",
    agent_has_ended_ar_markup_cannot_continue_without_agent:
        "Agent zakończył naliczanie opłat za rozliczenia. Nie można kontynuować naliczania opłat za rozliczenia bez agenta.",
    ar_markup_cancelled: "Anulowano narzut AR",
    ready_for_ar_markup: "Gotowy na znaczniki AR",
    max_ar_arrow_limit_toast_message: "Osiągnięto limit strzałek. Aby dodać więcej, użyj opcji „Wyczyść wszystko”.",
    video_paused: "wideo wstrzymane",
    discard_label: "Wyrzucać",
    go_room_call_limit_reached: "Osiągnięto limit połączeń w pokoju Go",
    circle: "Koło",
    arrow_with_text: "Strzałka z tekstem",
    add_shadow_and_stroke: "Dodaj cień i obrys",
    font_label: "Chrzcielnica:",
    file_type_not_supported: "Typ pliku(ów) nie jest obsługiwany",
    crt_acnt_enter_confirm_password: "Proszę potwierdzić hasło.",
    create_new_note_description: "Aby rozpocząć robienie notatek, kliknij przycisk Nowa notatka poniżej.",
    remote_user_stream_interrupted: "Przerwany strumień użytkownika zdalnego",
    audio_disabled_by_admin: "Dźwięk wyłączony przez administratora",
    audio_disabled: "Dźwięk wyłączony",
    dont_show_again: "Nie pokazuj ponownie",
    whatsapp_sent_label: "Zaproszenie WhatsApp wysłane!",
    whatsapp_label: "WhatsApp",
    having_an_issue_with_joining_the_call: "Masz problem z dołączeniem do rozmowy?",
    to_perform_network_check: "aby wykonać kontrolę sieci",
    you_were_removed_from_the_call_by_the_host: "Zostałeś usunięty z rozmowy przez gospodarza",
    you_have_been_removed_from_the_call_by_the_host_and_cannot_rejoin_now: "Organizator usunął Cię z rozmowy i nie możesz teraz dołączyć ponownie.",
    host_removed_you_from_the_call: "Gospodarz usunął Cię z rozmowy.",
    unable_to_join_the_call: "Nie można dołączyć do rozmowy",
    host_muted_your_microphone: "Gospodarz wyciszył Twój mikrofon.",
    unmute_your_microphone: "Wyłącz wyciszenie mikrofonu",
    host_invites_you_to_speak_unmute_your_microphone_when_ready: "Gospodarz zaprasza Cię do zabrania głosu. Włącz mikrofon, gdy będziesz gotowy.",
    got_it: "Zrozumiałem",
    unmute_mic: "Wyłącz wyciszenie mikrofonu",
    host_turned_off_your_camera: "Gospodarz wyłączył kamerę.",
    turn_your_camera_on: "Włącz kamerę",
    host_invites_you_to_turn_your_camera_on: "Gospodarz zaprasza Cię do włączenia kamery.",
    turn_camera_on: "Włącz kamerę",
    start_sharing_your_screen: "Rozpocznij udostępnianie ekranu",
    host_invites_you_to_share_your_screen: "Gospodarz zaprasza Cię do udostępnienia ekranu.",
    share_screen: "Udostępnij ekran",
    remove_all: "Usuń wszystko",
    remove: "Usunąć",
    end_call: "Zakończ połączenie",
    removing_all_participants_will_end_the_call: "Usunięcie wszystkich uczestników zakończy połączenie.",
    are_you_sure_you_want_to_remove_from_this_call: "Czy na pewno chcesz usunąć użytkownika <participantName> z tego połączenia?",
    block_from_rejoining_this_call: "Zablokuj użytkownikowi <participantName> możliwość ponownego dołączenia do tej rozmowy",
    turn_all_mics_off: "Wyłącz wszystkie mikrofony",
    turn_all_cams_off: "Wyłącz wszystkie kamery",
    ask_to_turn_mic_on: "Poproś o włączenie mikrofonu",
    turn_mic_off: "Wyłącz mikrofon",
    turn_cam_off: "Wyłącz kamerę",
    ask_to_turn_cam_on: "Poproś o włączenie kamery",
    ask_to_share_screen: "Poproś o udostępnienie ekranu",
    having_a_video_problem: "Masz problem z obrazem?",
    ios_play_pause_modal_body_text:
        "Spróbuj wyłączyć tryb oszczędzania energii w telefonie, aby rozwiązać ten problem. Możesz też kliknąć przycisk Odtwórz poniżej, aby odtworzyć film.",
    play_video: "Odtwórz wideo",
    camera_request_sent: "Prośba o udostępnienie aparatu została wysłana.",
    waiting_for_host_approval: "Oczekiwanie na akceptację gospodarza.",
    microphone_request_sent: "Wysłano prośbę o mikrofon.",
    camera_request_denied: "Prośba o udostępnienie kamery odrzucona.",
    click_the_camera_icon_if_you_need_to_request_again: "Jeśli chcesz wysłać prośbę ponownie, kliknij ikonę aparatu.",
    microphone_request_denied: "Prośba o mikrofon została odrzucona.",
    click_the_mic_icon_if_you_need_to_request_again: "Kliknij ikonę mikrofonu, jeśli chcesz poprosić ponownie.",
    deny: "Zaprzeczyć",
    allow: "Umożliwić",
    user_wants_to_start_their_camera: "<ParticipantName> chce uruchomić swój <micOrCam>",
    error_in_processing_live_caption_please_retry: "Wystąpił błąd podczas przetwarzania napisów na żywo. Spróbuj ponownie.",
    virtual_background: "Tło wirtualne",
    upload_image: "Prześlij obraz",
    remove_image: "Usuń obraz",
    remove_background_image: "Usuń obraz tła",
    are_you_sure_you_want_to_remove_background_image: "Czy na pewno chcesz usunąć obraz tła?",
    unsupported_file_format: "Nieobsługiwany format pliku.",
    the_maximum_file_size_supported_is_in_mb: "Maksymalny obsługiwany rozmiar pliku wynosi <size> MB.",
    no_effect: "Brak efektu",
    blur_background: "Rozmycie tła",
    default_image: "Domyślny obraz",
    virtual_background_not_supported: "Tło wirtualne nie jest obsługiwane.",
    remove_from_call: "Usuń z połączenia",
    enable_offline_mode: "Włącz tryb offline",
    offline_mode_enabled: "Włączony tryb offline",
    your_images_will_upload_when_you_reconnect: "Twoje zdjęcia zostaną przesłane po ponownym połączeniu.",
    please_keep_this_screen_open: "Proszę pozostawić ten ekran otwartym.",
    max_images_upload: "Maksymalna liczba obrazów <count>",
    remaining_image_count_label: "<remainingCount> z <totalCount> obrazów",
    selected_images: "Wybrane obrazy",
    offline_uploads_are_not_supported_in_private_mode: "Przesyłanie plików w trybie offline nie jest obsługiwane w trybie prywatnym.",
    please_switch_to_a_normal_browser_tab_to_use_this_feature: "Aby skorzystać z tej funkcji, przejdź do normalnej karty przeglądarki.",
    guest_is_using_a_private_browser_window: "Gość korzysta z prywatnego okna przeglądarki.",
    offline_upload_mode_is_not_supported_in_this_case: "W tym przypadku tryb przesyłania offline nie jest obsługiwany.",
    some_images_failed_to_upload_due_to_a_network_error: "Niektóre obrazy nie zostały przesłane z powodu błędu sieci.",
    closing_this_modal_will_discard_all_the_images_you_have_selected_during_offline_mode:
        "Zamknięcie tego okna spowoduje usunięcie wszystkich obrazów wybranych w trybie offline.",
    live_captions_stopped: "Napisy na żywo zostały wyłączone.",
    translate: "Tłumaczyć",
    auto_translate: "Automatyczne tłumaczenie",
    your_language: "Twój język",
    translation_info_text: "Wiadomości od innych uczestników zostaną automatycznie przetłumaczone na wybrany język.",
    translating: "Tłumaczenie...",
    show_original: "Pokaż oryginał",
    show_translation: "Pokaż tłumaczenie",
    translated: "Przetłumaczony",
    send_message_in: "Wyślij wiadomość w",
    audio_translation: "Tłumacz",
    audio_translation_setup: "Tłumaczenie Audio",
    they_speak: "Oni mówią",
    i_want_to_hear: "Chcę słyszeć",
    start_translation: "Rozpocznij Tłumaczenie",
    stop_translation: "Zatrzymaj Tłumaczenie",
    starting_translation: "Rozpoczynanie tłumaczenia...",
    translation_started: "Tłumaczenie audio rozpoczęte.",
    translation_stopped: "Tłumaczenie audio zatrzymane.",
    translation_error: "Błąd tłumaczenia. Spróbuj ponownie.",
    translation_active: "Tłumaczenie aktywne",
    voice_type: "Głos",
    voice_female: "Żeński",
    voice_male: "Męski",
};

export default pl;
